<div *ngIf="isLoadedData" class="totalPrepaid">{{ 'prepaid_total' | translate }}: <b>{{ prepaidAmount | currencyReduce: true | currency:prepaidAmount: 'zł' }}</b> </div>
